import { GOLD, BLUE } from "../constants/temas";

const TABS = [
    {
        id: "home",
        label: "Início",
        icon: (ativo, T) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={ativo ? GOLD : T.textoSecundario}>
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
        )
    },
    {
        id: "escala",
        label: "Escala",
        icon: (ativo, T) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={ativo ? GOLD : T.textoSecundario}>
                <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
            </svg>
        )
    },
    {
        id: "musicas",
        label: "Músicas",
        icon: (ativo, T) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={ativo ? GOLD : T.textoSecundario}>
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            </svg>
        )
    },
    {
        id: "rede",
        label: "Equipe",
        icon: (ativo, T) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={ativo ? GOLD : T.textoSecundario}>
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
            </svg>
        )
    },
    {
        id: "perfil",
        label: "Perfil",
        icon: (ativo, T) => (
            <svg width="22" height="22" viewBox="0 0 24 24" fill={ativo ? GOLD : T.textoSecundario}>
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
        )
    },
];

export default function Navbar({ tab, setTab, T }) {
    return (
        <div style={{
            position: "fixed", bottom: 0, left: "50%",
            transform: "translateX(-50%)", width: "100%", maxWidth: 430,
            background: T.nav,
            borderTop: `1px solid ${T.borda}`,
            display: "flex", zIndex: 100,
            boxShadow: "0 -4px 24px rgba(0,0,0,0.08)",
            paddingBottom: "env(safe-area-inset-bottom, 0px)",
        }}>
            {TABS.map(t => {
                const ativo = tab === t.id;
                return (
                    <button
                        key={t.id}
                        onClick={() => setTab(t.id)}
                        style={{
                            flex: 1, paddingTop: 10, paddingBottom: 8,
                            border: "none", background: "none", cursor: "pointer",
                            display: "flex", flexDirection: "column",
                            alignItems: "center", gap: 3,
                            position: "relative",
                        }}
                    >
                        {/* Indicador ativo */}
                        {ativo && (
                            <div style={{
                                position: "absolute", top: 0, left: "50%",
                                transform: "translateX(-50%)",
                                width: 32, height: 3, borderRadius: "0 0 3px 3px",
                                background: GOLD,
                            }} />
                        )}

                        {/* Fundo do ícone quando ativo */}
                        <div style={{
                            width: 36, height: 28, borderRadius: 10,
                            background: ativo ? `${GOLD}18` : "transparent",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            transition: "background 0.2s",
                        }}>
                            {t.icon(ativo, T)}
                        </div>

                        <span style={{
                            fontSize: 10,
                            color: ativo ? GOLD : T.textoSecundario,
                            fontWeight: ativo ? 700 : 400,
                            letterSpacing: ativo ? 0.2 : 0,
                        }}>
                            {t.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}